import React, { FC, useEffect, useMemo, useState } from 'react';
import { IBlockData } from '../../../../interfaces/interfaces';
import { Input, Button, Collapse, App, Popconfirm, Form } from 'antd';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../../../../../core/redux';
import { tablesSlice } from '../../../../TablesSlice';
import {
  getAddedMaxData,
  getBlockStatus,
  getCaseInsensitiveTextSearch,
  getIndexSearchText,
  getParentDataOptions,
  getValidateCase,
  loopInfoData,
  loopUniqueEnglishName,
  saveDataInMaxData,
} from '../../../../helpers/helpers';
import { XPathContentChildren } from './XPathContentChildren/XPathContentChildren';
import { projectsApiService } from '../../../../../../api/projects/projectsApiService';
import { notificationMessages, showNotification } from '../../../../../usersPage/helpers/helpers';
import { ITitle } from '../../../../../usersPage/interfaces/interfaces';

import s from './XPathBlock.module.scss';
import Types from '../../../../../../../types/types';
const { initTabs } = Types;

const {
  setMaxData,
  setCheckedKeysXPathes,
  setParentCodeOptions,
  setExpandedKeys,
  setActiveBlockKeys,
  setHasUnsavedChanges,
  setError,
} = tablesSlice.actions;
export const XPathBlock: FC<IBlockData> = ({
  blockData,
  searchValue,
  strTitle,
  id,
  attributeTypeOptions,
}) => {
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [title, setTitle] = useState(strTitle);
  // const [blockIsActive, setBlockIsActive] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const {
    englishName,
    description,
    attributeType,
    isParent,
    section,
    oidDirectory,
    xmlPath,
    mandatory_plurality,
    parentCode,
    result,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ...props
  } = blockData;
  const initialBlockData = {
    currentEnglishName: englishName,
    currentAttributeType: attributeType,
    currentXmlPath: xmlPath,
    currentParentCode: parentCode,
    currentMandatoryPlurality: mandatory_plurality,
    currentOidDirectory: oidDirectory,
    currentSection: section,
    currentDescription: description,
    currentIsParent: isParent,
    currentResult: result,
    showAllSettings: false,
    key: id,
  };

  const [formData, setFormData] = useState(initialBlockData);
  const [hasChangeXPath, setHasChangeXPath] = useState(false);

  const { ...fd } = formData;
  const [
    checkingCorrectnessXPath,
    {
      data: checkingCorrectnessXPathData,
      error: checkingCorrectnessXPathError,
      isLoading: checkingCorrectnessXPathLoading,
    },
  ] = projectsApiService.useGetCheckingCorrectnessXPathMutation();

  const {
    maxData,
    activeXmlTab,
    cdaRedactorTabs,
    parentCodeOptions,
    searchXPathVal,
    activeBlocksKeys,
    expandedKeys,
    hasUnsavedChanges,
    xPathErrors,
  } = useAppSelector((state) => state.tablesSlice);
  const isActive = activeBlocksKeys.includes(id);
  const handleSetHasChanges = () => {
    const hasChanges = { ...hasUnsavedChanges, [initTabs['CDA']]: true };
    const has = hasUnsavedChanges[initTabs['CDA']];
    if (!has) {
      dispatch(setHasUnsavedChanges(hasChanges));
    }
  };

  const saveXPath = () => {
    const xPathBlockData = {
      englishName: formData.currentEnglishName || englishName,
      attributeType: fd.currentAttributeType || attributeType,
      isParent: fd.currentIsParent,
      section: fd.currentSection || section,
      oidDirectory: fd.currentOidDirectory || oidDirectory,
      mandatory_plurality: fd.currentMandatoryPlurality || mandatory_plurality,
      xmlPath: fd.currentXmlPath || xmlPath,
      parentCode: fd.currentParentCode || parentCode,
      result: fd.currentResult || result,
      key: id,
      ...props,
    };

    const data = [...maxData];
    const newMaxData = saveDataInMaxData(data, xPathBlockData, title);
    const parentCodeOptions = getParentDataOptions(newMaxData);

    dispatch(setParentCodeOptions(parentCodeOptions));
    dispatch(setMaxData(newMaxData));
    dispatch(setCheckedKeysXPathes([]));
    handleSetHasChanges();
    // dispatch(setExpandedKeys([]));
  };
  const handleChangeFormData = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };
  const handleClickHeaderTab = () => {
    const errors = new Set(xPathErrors);
    if (errors.has(id)) {
      return;
    }
    let activeBlocks = [];
    if (isActive) {
      handleSaveXPath();
      activeBlocks = activeBlocksKeys.filter((actId) => actId !== id);
    } else {
      activeBlocks = [...activeBlocksKeys, id];
    }
    dispatch(setActiveBlockKeys(activeBlocks));
    setFormData({ ...initialBlockData });
  };
  const onAddXPath = (id) => {
    const reFreezeMaxData = maxData ? [...maxData] : [];
    const { data: newData, newBlockKey } = getAddedMaxData(reFreezeMaxData, id);

    // const newData = getAddedMaxData(reFreezeMaxData, id);
    const parentCodeOptions = getParentDataOptions(newData);
    dispatch(setParentCodeOptions(parentCodeOptions));
    dispatch(setMaxData(newData));
    dispatch(setExpandedKeys([...expandedKeys, id]));
    handleSetHasChanges();
    setTimeout(() => {
      dispatch(setActiveBlockKeys([newBlockKey]));
      const newBlock = document.getElementById(`${newBlockKey}`);
      newBlock.scrollIntoView({ block: 'center', inline: 'center' });
    }, 500);
  };
  const deleteXPath = () => {
    const data = [...maxData];
    loopInfoData(data, id, (node, i, parent) => {
      parent.splice(i, 1);
    });
    const parentCodeOptions = getParentDataOptions(data);
    dispatch(setParentCodeOptions(parentCodeOptions));
    dispatch(setMaxData(data));
    dispatch(setCheckedKeysXPathes([]));
    handleSetHasChanges();
    setOpenConfirm(false);
  };
  const handleSaveXPath = () => {
    const errors = new Set(xPathErrors);
    if (errors.has(id)) {
      return;
    }
    form.resetFields();

    const isUniqCode = loopUniqueEnglishName(maxData, fd.currentEnglishName, id);
    if (isUniqCode.length >= 1) {
      showNotification(notification, notificationMessages.enterUniqueEnglishName, ' ', 'error');
      return;
    }
    setHasChangeXPath(true);
    saveXPath();
  };
  const handleSetError = (err) => {
    const newErrors = new Set(xPathErrors);
    newErrors.add(err);
    console.log('ADD newErrors', newErrors);
    dispatch(setError(Array.from(newErrors)));
  };
  const handleDeleteError = (err) => {
    const newErrors = new Set(xPathErrors);
    newErrors.delete(err);
    console.log('DELETE newErrors', newErrors);
    dispatch(setError(Array.from(newErrors)));
  };
  const handleValidationXPathCheck = () => {
    const currentTab =
      cdaRedactorTabs.find((tab) => tab.key === activeXmlTab) || cdaRedactorTabs[0];
    if (!currentTab.code && !!fd.currentXmlPath) {
      showNotification(notification, notificationMessages.absentXml, ' ', 'error');
      return;
    }
    checkingCorrectnessXPath({ file_name: currentTab.fileName, xpath_string: fd.currentXmlPath });
  };

  // const index = title.indexOf(searchValue);
  const index = getIndexSearchText(title, searchValue);
  const beforeStr = title.substring(0, index);
  const afterStr = title.slice(index + searchValue.length);
  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setOpenConfirm(newOpen);
      return;
    }
    setOpenConfirm(newOpen);
  };
  const renderEditableTitle = (title) => {
    return (
      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        <Form.Item<ITitle>
          name={'title'}
          initialValue={title}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  handleSetError(fd.key);
                  return Promise.reject(new Error('Обязательно для заполнения'));
                }
                const cond = getValidateCase(getFieldValue('title'), 'ru');
                if (cond) {
                  handleDeleteError(fd.key);
                  setTitle(value);
                  return Promise.resolve();
                }
                handleSetError(fd.key);
                return Promise.reject(new Error('Разрешен ввод только на русском языке'));
              },
            }),
          ]}
          className={`${s.field} ${s.title}`}
        >
          <Input
            onBlur={handleSaveXPath}
            onClick={(event) => {
              event.stopPropagation();
            }}
          />
        </Form.Item>
        {fd.currentIsParent ? (
          <Button
            style={{ background: 'transparent', border: 'none' }}
            size={'small'}
            icon={<PlusCircleOutlined />}
            onClick={(event) => {
              event.stopPropagation();
              onAddXPath(id);
            }}
            shape='circle'
          ></Button>
        ) : (
          ''
        )}
        <Popconfirm
          title='Вы действительно хотите удалить xPath?'
          // description='Are you sure to delete this task?'
          onConfirm={(event) => {
            event.stopPropagation();
            deleteXPath();
          }}
          open={openConfirm}
          onOpenChange={handleOpenChange}
          onCancel={() => console.log('onCancel')}
          okText='Да'
          cancelText='Нет'
        >
          <Button
            style={{ background: 'transparent', border: 'none' }}
            size={'small'}
            icon={<DeleteOutlined />}
            danger
            onClick={(event) => {
              event.stopPropagation();
              setOpenConfirm(true);
            }}
            shape='circle'
          ></Button>{' '}
        </Popconfirm>
      </div>
    );
  };

  const initItems = [];
  const label =
    index > -1 && searchValue ? (
      <span style={{ width: '100%' }}>
        {beforeStr}
        <span className='site-tree-search-value'>{searchValue}</span>
        {afterStr}
      </span>
    ) : (
      <div style={{ width: '100%' }}>
        {!isActive ? <span>{title}</span> : renderEditableTitle(title)}
      </div>
    );
  initItems.push({
    key: id,
    label: (
      <div style={{ display: 'flex', gap: '10px' }}>
        {getBlockStatus(fd.currentResult)} {label}
      </div>
    ),
    children: (
      <XPathContentChildren
        parentCodeOptions={parentCodeOptions}
        attributeTypeOptions={attributeTypeOptions}
        fd={fd}
        hasChangeXPath={hasChangeXPath}
        setHasChangeXPath={setHasChangeXPath}
        handleChangeFormData={handleChangeFormData}
        handleValidationXPathCheck={handleValidationXPathCheck}
        xPathResponse={fd.currentResult}
        handleSaveXPath={handleSaveXPath}
        setError={handleSetError}
        deleteError={handleDeleteError}
      />
    ),
  });
  const isSearched = useMemo(() => {
    return (
      searchValue &&
      (getCaseInsensitiveTextSearch(fd.currentEnglishName, searchValue) ||
        getCaseInsensitiveTextSearch(fd.currentOidDirectory, searchValue) ||
        getCaseInsensitiveTextSearch(fd.currentSection, searchValue) ||
        getCaseInsensitiveTextSearch(fd.currentDescription, searchValue))
    );
  }, [searchXPathVal, fd]);

  useEffect(() => {
    if (
      checkingCorrectnessXPathData &&
      !checkingCorrectnessXPathError &&
      !checkingCorrectnessXPathLoading
    ) {
      handleChangeFormData('currentResult', checkingCorrectnessXPathData);
    }

    if (
      !checkingCorrectnessXPathData &&
      checkingCorrectnessXPathError &&
      !checkingCorrectnessXPathLoading
    ) {
      handleChangeFormData('currentResult', 'error');
      setHasChangeXPath(false);
    }
  }, [
    checkingCorrectnessXPathData,
    checkingCorrectnessXPathError,
    checkingCorrectnessXPathLoading,
  ]);
  useEffect(() => {
    if (result) {
      handleChangeFormData('currentResult', result);
      // setHasChangeXPath(false);
    } else {
      handleChangeFormData('currentResult', '');
      setHasChangeXPath(false);
    }
  }, [result]);
  useEffect(() => {
    if (fd.currentIsParent !== isParent) {
      handleSaveXPath();
    }
  }, [fd.currentIsParent, isParent]);
  return (
    <div
      id={id}
      className={s.CollapsedBlock}
      style={{ background: isSearched ? 'yellow' : 'white' }}
    >
      <Form form={form} layout='vertical'>
        <Collapse
          onChange={handleClickHeaderTab}
          items={initItems}
          bordered={true}
          expandIconPosition={'end'}
          activeKey={activeBlocksKeys}
        />
      </Form>
    </div>
  );
};
